import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';
const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getStockRequests = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/stock-requests`, { ...withAuth(), params })).data;

export const createStockRequest = async (branchId, data = {}) =>
  (await axios.post(`${API_URL}/branch/${branchId}/stock-requests`, data, withAuth())).data;

export const getStockRequestById = async (branchId, id) =>
  (await axios.get(`${API_URL}/branch/${branchId}/stock-requests/${id}`, withAuth())).data;

export const updateStockRequest = async (branchId, id, data = {}) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/stock-requests/${id}`, data, withAuth())).data;

export const deleteStockRequest = async (branchId, id) =>
  (await axios.delete(`${API_URL}/branch/${branchId}/stock-requests/${id}`, withAuth())).data;

export const sendStockRequest = async (branchId, id) =>
  (await axios.post(`${API_URL}/branch/${branchId}/stock-requests/${id}/send`, {}, withAuth())).data;

export const addStockRequestItem = async (branchId, id, data = {}) =>
  (await axios.post(`${API_URL}/branch/${branchId}/stock-requests/${id}/items`, data, withAuth())).data;

export const updateStockRequestItem = async (branchId, id, itemId, data = {}) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/stock-requests/${id}/items/${itemId}`, data, withAuth())).data;

export const deleteStockRequestItem = async (branchId, id, itemId) =>
  (await axios.delete(`${API_URL}/branch/${branchId}/stock-requests/${id}/items/${itemId}`, withAuth())).data;

export const getIncomingPendingStockRequests = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/stock-requests/incoming/pending`, { ...withAuth(), params })).data;
